module.exports = __webpack_public_path__ + "static/media/email-icon.84f5f994.svg";